import React from 'react';
import { connect } from 'react-redux';
import { Table } from 'reactstrap';
import i18n from "../../../i18next";
import MaterialIcon from "material-icons-react";

import CustomerInsightSearchOptions from './CustomerInsightSearchOptions';
import { loadCustomerInsightPaymentSearchSummary } from '../../../actions/restaurants/customerInsight/CustomerInsightAction';
import { loadRestaurantInsightPaymentSearchSummary } from '../../../actions/restaurants/restaurantInsight/RestaurantInsightAction';
import { getPriceWithCurrencySymbol } from '../../../utils/CommonUtils';
import CashSVG from '../../common/svgs/CashSVG';
import CardsSVG from '../../common/svgs/CardsSVG';
import LoyaltyIconSvg from '../../common/svgs/LoyaltyIconSVG';
import GiftCardSVG from '../../common/svgs/GiftCardSvg';

class PaymentTypeSearch extends React.Component {

    state = {
        fromDate: '',
        toDate: ''
    }

    componentDidMount() {
        const { restaurantId, customerId } = this.props;

        if(this.props.insightType ==='restaurant') {
            this.props.loadRestaurantInsightPaymentSearchSummary(restaurantId, this.state.fromDate, this.state.toDate);
        } else {
            this.props.loadCustomerInsightPaymentSearchSummary(restaurantId, customerId, this.state.fromDate, this.state.toDate);
        }
    }

    takeSearchOptionState = searchOptionState => {
        const { restaurantId, customerId } = this.props;

        if(this.props.insightType ==='restaurant') {
            this.setState({
                fromDate: searchOptionState.fromDate,
                toDate: searchOptionState.toDate
            })
            
            this.props.loadRestaurantInsightPaymentSearchSummary(restaurantId, searchOptionState.fromDate, searchOptionState.toDate);
        } else {
            this.setState({
                fromDate: searchOptionState.fromDate,
                toDate: searchOptionState.toDate
            })

            this.props.loadCustomerInsightPaymentSearchSummary(restaurantId, customerId, searchOptionState.fromDate, searchOptionState.toDate);
        }  
    }

    renderPaymentTypeTable = () => {
        return (
            <Table bordered hover style={{ marginTop: '5px' }}>
                <thead>
                    {this.renderTableHeaders()}
                </thead>
                <tbody>
                    {this.renderTableContent()}
                </tbody>
            </Table>
        );
    }

    renderTableHeaders = () => {

        const { tableHeaders, textCenter, textRight } = styles;

        return (
            <tr>
                <th style={{ ...tableHeaders }}>{i18n.t('screens:customerInsightScreen.paymentType')}</th>
                <th style={{ ...tableHeaders, ...textCenter }}>{i18n.t('screens:customerInsightScreen.count')}</th>
                <th style={{ ...tableHeaders, ...textRight }}>{i18n.t('screens:customerInsightScreen.totalSpent')}</th>
                <th style={{ ...tableHeaders, ...textRight }}>{i18n.t('screens:customerInsightScreen.serviceFee')}</th>
            </tr>
        );
    }

    renderTableContent = () => {

        if(this.props.insightType ==='restaurant' && this.props.restaurantInsightPaymentTypes) {
            return this.props.restaurantInsightPaymentTypes.map(item => {
                return this.renderSingleItem(item);
            })
        } else {
            return this.props.customerInsightPaymentTypes.map(item => {
                return this.renderSingleItem(item);
            })
        }
    }

    renderSingleItem = item => {

        const { tableDetail, firstRow, textCenter, textRight, iconStyle } = styles;
        const currency = this.props.restaurant.currency;

        return (
            <tr>
                <td style={{ ...tableDetail, ...iconStyle }}>{this.renderPaymentSVGIcon(item.typeOrName)}&nbsp;&nbsp;{this.renderPaymentTypeName(item.typeOrName)}</td>
                <td style={{ ...tableDetail, ...textCenter }}>{item.count}</td>
                <td style={{ ...tableDetail, ...textRight }}>{getPriceWithCurrencySymbol(item.totalSpent, currency)}</td>
                <td style={{ ...tableDetail, ...textRight }}>{getPriceWithCurrencySymbol(item.serviceFee, currency)}</td>
            </tr>
        );
    }

    renderPaymentSVGIcon = type => {
        switch (type) {
            case "CreditCard": return <CardsSVG width={15} height={15} fill={'#0288D1'} />
            case "Cash": return <CashSVG width={15} height={15} fill={'#0288D1'} />
            case "Loyalty": return <LoyaltyIconSvg width={15} height={15} fill={'#0288D1'} />
            case "Gift card": return <GiftCardSVG  width={20} height={20} fill={'#0288D1'} />
            default: return null
        }
    }

    renderPaymentTypeName = type => {
        switch (type) {
            case "CreditCard": return i18n.t('screens:customerInsightScreen.creditCard');
            case "Cash": return i18n.t('screens:customerInsightScreen.cash');
            case "Loyalty": return i18n.t('screens:customerInsightScreen.loyalty');
            case "Gift card": return i18n.t('screens:restaurantInsightScreen.giftCard');
            default: return null
        }
    }

    render() {
        return (
            <React.Fragment>
                <CustomerInsightSearchOptions type="PaymentTypes" takeSearchOptionState={this.takeSearchOptionState} />
                {this.renderPaymentTypeTable()}
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        customerInsightPaymentTypes: state.customerInsightPaymentTypes,
        restaurantInsightPaymentTypes: state.restaurantInsight.paymentTypeSummary,
        restaurant: state.restaurant
    }
};

export default connect(mapStateToProps, { 
    loadCustomerInsightPaymentSearchSummary,
    loadRestaurantInsightPaymentSearchSummary })(PaymentTypeSearch);

const styles = {
    tableHeaders: {
        padding: '10px',
        fontSize: '16px',
        fontWeight: 'bold',
    },
    tableDetail: {
        padding: '10px',
        fontSize: '14px',   //previously it was 14px not bolded
        fontWeight: 'bold',
    },
    firstRow: {
        //whiteSpace: 'nowrap'
        paddingRight: '0'
    },
    textCenter: {
        textAlign: 'center',
        padding: '10px 5px'
    },
    textRight: {
        textAlign: 'right',
        paddingLeft: '0'
    },
    iconStyle: {
        display: 'flex',
        alignItems: 'center'
    }
}


// WEBPACK FOOTER //
// ./src/components/restaurants/customerInsightScreen/PaymentTypeSearch.js